module.exports = __webpack_public_path__ + "img/1-fr.c97940f5.jpg";